import { __require as requireLodash } from './node_modules-lodash-lodash.js';

var lodashExports = requireLodash();

export { lodashExports as l };
//# sourceMappingURL=_virtual-lodash.js.map
